export default __webpack_public_path__ + "static/media/werking-dashboard.a0604ca4.JPG";